import React from 'react';
import { Button, ButtonGroup, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import { Form } from '../../../form';
import { FormSectionInfo } from '../../../form/components';
import { InputText } from '../../../input';
import { RHFInputText } from '../../../../packages/react-hook-form';
import { MaskedSwedishSsnInput } from '../../../input/components';
import { FormSectionContainer } from '../../../form/components/form-section-container/form-section-container';
import { SWEDISH_SSN_PLACEHOLDER } from '../../../../global/constants';
import { BuyProcessFormNextButton } from '../buy-process-form-next-button/buy-process-form-next-button';
import { BuyProcessFormAdminSubmitButton } from '../buy-process-form-admin-submit-button/buy-process-form-admin-submit-button';
import { useProxies } from './use-proxies';

const useStyles = makeStyles((theme) => ({
  inputGroup: {
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
}));

export const BuyProcessFormProxies = () => {
  const classes = useStyles();
  const {
    setFirstName,
    setLastName,
    setSsn,
    people,
    onSubmit,
    register,
    formMethods,
    onBack,
    onForward,
    isUpdating,
  } = useProxies();

  const { lastName, socialSecurityNumber, firstName } = formMethods.watch([
    'socialSecurityNumber',
    'lastName',
    'firstName',
  ]);

  return (
    <Form onSubmit={onSubmit}>
      <div>
        <FormSectionInfo.InfoBoxTitled title="Bank- och Generalfullmakt">
          <Typography>
            När du köper ett lagerbolag måste bolagets aktiekapital sättas in på
            bolagets bankkonto. Vi upprättar en bankfullmakt till dig som gör
            det möjligt att öppna ett bankkonto i bolagets organisationsnummer
            och göra en insättning på hela aktiekapitalet. Efter insättningen på
            bankkontot och köpavtalet har undertecknats utfärdar vi en
            generalfullmakt som ger rätt att fullt ut företräda det nya bolaget.
            Denna fullmakt behövs tills ärendet har registrerats hos
            Bolagsverket. Ange den person som dessa två fullmakter ska ställas
            ut till nedan.
          </Typography>
        </FormSectionInfo.InfoBoxTitled>

        <FormSectionContainer>
          <div className={classes.inputGroup}>
            <input ref={register} name="relationId" hidden />

            <Autocomplete
              freeSolo
              fullWidth
              options={people}
              getOptionLabel={(option) => option?.firstName ?? ''}
              value={{
                firstName,
                lastName,
                socialSecurityNumber,
              }}
              onChange={(_, value) => {
                if (typeof value === 'string') {
                  setFirstName(value);
                  return;
                }

                setFirstName(value?.firstName);
                setLastName(value?.lastName);
                setSsn(value?.socialSecurityNumber);
              }}
              renderOption={(option) => (
                <Typography>
                  {option.firstName} {option.lastName} (
                  {option.socialSecurityNumber})
                </Typography>
              )}
              renderInput={(params) => (
                <InputText
                  {...params}
                  value={formMethods.getValues('firstName')}
                  onChange={(event) => setFirstName(event.target.value)}
                  label="Samtliga förnamn"
                  required
                  errors={formMethods.errors}
                  name="firstName"
                />
              )}
            />

            <RHFInputText
              required
              control={formMethods.control}
              label="Efternamn"
              errors={formMethods.errors}
              name="lastName"
            />

            <RHFInputText
              placeholder={SWEDISH_SSN_PLACEHOLDER}
              required
              label="Personnummer"
              control={formMethods.control}
              InputProps={{ inputComponent: MaskedSwedishSsnInput }}
              errors={formMethods.errors}
              name="socialSecurityNumber"
            />
          </div>
        </FormSectionContainer>
      </div>

      <ButtonGroup>
        <Button onClick={onBack}>Tillbaka</Button>
        <BuyProcessFormNextButton onClick={onForward}>
          Nästa
        </BuyProcessFormNextButton>
        <BuyProcessFormAdminSubmitButton loading={isUpdating}>
          Spara
        </BuyProcessFormAdminSubmitButton>
      </ButtonGroup>
    </Form>
  );
};
